import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-patients-list',
  templateUrl: './patients-list.component.html',
  styleUrls: ['./patients-list.component.scss']
})
export class PatientsListComponent implements OnInit {
	
	
  	constructor(private dataService: DataService) { }
  	data = [];

  	role_id:any = '';
  	key:any;
  	limit = 20;
  	search = "";
  	department= 0;
  	departments = [];
  	edit = { 'treatment':'' };
  	role = localStorage.getItem('role_id');
	loading:any = 0;
	tags = [];
	tag = "";
	gender:any = "";
	dr1:any = "";
	dr2:any = "";
	lower:any = "";
	upper:any = "";
	showFilters:any = true;
  	
	ngOnInit() {


		//load key from localStrorage
	    this.key = localStorage.getItem('key');
	    this.role_id = localStorage.getItem('role_id');
	    this.loadPatients();
	    this.loadDepartments();
		this.loadTags();
	}

	loadPatients() {
		this.loading = 1;
		this.dataService.getPatients(this.limit, this.search, this.department, this.tag, this.gender, this.dr1, this.dr2, this.lower, this.upper).subscribe( (data: any )=> {
	  		this.data = data;
	  		this.loading = 0;
	  	} );
	}

	toggleFilterVisibility(){
		this.showFilters = !this.showFilters;
	}

	loadTags(){
		this.dataService.getTags().subscribe( (data: any )=> {
	  		this.tags = data;
	  		
	  	} );
	}

	loadDepartments() {
		
		this.dataService.getDepts().subscribe( (data: any )=> {
	  		this.departments = data;
	  		console.log(data);
	  		
	  		
	  	} );
	}

	searchPatients(search) {
		this.search = search;
		this.loadPatients();
	}

	loadMore() {
		this.limit +=20;
		this.loadPatients();
	}

	filterDepartment(val){
		this.department = val;
		this.loadPatients();
	}

	loadPatient(id){
		this.edit = { 'treatment':'' };
	    this.dataService.getPatientProfile(id).subscribe( (data: any )=> {
	    	//@ts-ignore
	      	this.edit = data;
	      	console.log(this.edit);
	      
	      
	    } );
  	}	

  	submitEdit(data){
  		//@ts-ignore
	    data.patient_id = this.edit.patient_id;
	    data.apl_bpl = $('input[name="apl_bpl"]:checked').val();
	    data.gender = $('input[name="gender"]:checked').val();
	    data.employment_status = $('input[name="employment_status"]:checked').val();
	    data.docinstructions = $('input[name="docinstructions"]:checked').val();
	    data.examination = $('input[name="examination"]:checked').val();
	    data.patient_since = $('#editSince').val();
	    data.dob = $('#editDOB').val();

	    var treatments = [];

	    $('ul.edit-treatments li').each(function(){
	      if( $(this).hasClass('active') ) {
			//@ts-ignore
	        treatments.push( $(this).text() );
	      }
	    })

	    data.treatments = treatments;

	    $('#btn-edit').text('Submitting');
	    $('#btn-edit').attr('disabled', 'true');
	    
	    
	    
	    this.dataService.postEditPatient(data).subscribe( (res:any) => {
	      $('#btn-edit').text('Submit');
	      $('#btn-edit').removeAttr('disabled');
	      if(res.status == 0){
	        $('#editPatient').modal('hide');
	        this.loadPatients();
	        
	      } else {
	        alert(res.msg);
	      }

	    });
	    
	}

	searchTags(tag){
		this.tag = tag;
		this.dataService.setLocalData("filterTag", tag);
		this.loadPatients();
	}

	dateRegFilter(): void {
		if (this.dr1 && this.dr2 && this.isValidDate(this.dr1) && this.isValidDate(this.dr2)) {
		  console.log('Valid date range:', this.dr1, 'to', this.dr2);
		  this.loadPatients();
		} 
	  }
	  
	private isValidDate(date: any): boolean {
		return !isNaN(new Date(date).getTime());
	}

	ageRangeFilter(): void {
		if (this.isValidNumber(this.lower) && this.isValidNumber(this.upper) && this.upper >= this.lower) {
			console.log('Valid age range:', this.lower, 'to', this.upper);
			this.loadPatients();
		} 
	}
	
	private isValidNumber(value: any): boolean {
		return typeof value === 'number' && !isNaN(value);
	}

}
